export default __webpack_public_path__ + "static/media/default-image-response.1a4253ea.png";